const main = () => {
    const panel = document.querySelector('.c-others-search-menu');
    if (!panel) return;

    const triggers = document.querySelectorAll('[data-open-search-menu]');
    if (!triggers.length) return;

    const close = () => {
        panel.removeAttribute('data-is-open');
        panel.setAttribute('aria-hidden', 'true');
        triggers.forEach(t => t.setAttribute('aria-expanded', 'false'));
    };

    const open = () => {
        panel.setAttribute('data-is-open', '');
        panel.setAttribute('aria-hidden', 'false');
        triggers.forEach(t => t.setAttribute('aria-expanded', 'true'));
    };

    triggers.forEach(trigger => {
        trigger.addEventListener('click', (e) => {
            e.preventDefault();
            if (panel.hasAttribute('data-is-open')) {
                close();
            } else {
                open();
            }
        });
    });

    panel.querySelectorAll('[data-search-close]').forEach(el => {
        el.addEventListener('click', close);
    });

    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && panel.hasAttribute('data-is-open')) {
            close();
        }
    });
};

export default main;
